import * as React from "react";
import * as cn from "classnames";

export interface SvgIconProps {
    svg: string;
    className?: string;
    title?: string;
}

export function SvgIcon(props: SvgIconProps) {
    return <span className={cn(props.className)} dangerouslySetInnerHTML={{ __html: props.svg }} title={props.title} />;
}
